import { useState } from "react";
import styled from "styled-components";

import { Alert as BaseAlert, Clickable, Text } from "@otta/design";
import { palette, pxToRem } from "@otta/design-tokens";
import { Icon } from "@otta/icons";

export const missingSalaryWarningLocalStorageKey = "missing-salary-warning";

const Alert = styled(BaseAlert)`
  margin: ${pxToRem(16)} 0;
  border-radius: ${pxToRem(4)};
`;

const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const SalaryOffIcon = styled(Icon).attrs({
  icon: "salary-off",
  size: 2,
})`
  margin-right: ${pxToRem(8)};
  color: ${palette.extended.orange.shade600};
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(4)};
  margin-right: ${pxToRem(24)};
`;

export const MissingSalaryWarning = () => {
  const [isOpen, setIsOpen] = useState(
    () => localStorage.getItem(missingSalaryWarningLocalStorageKey) !== "true"
  );

  if (!isOpen) return null;

  const handleClickClose = () => {
    setIsOpen(false);
    localStorage.setItem(missingSalaryWarningLocalStorageKey, "true");
  };

  return (
    <Alert level="warning">
      <Wrapper data-testid="missing-salary-warning">
        <SalaryOffIcon />
        <ContentWrapper>
          <Text size={0} bold>
            Your jobs are missing salaries
          </Text>
          <Text size={0}>
            You can add public or hidden salaries to jobs. Hidden salaries
            aren&apos;t shown to candidates. They ensure your job is matched
            with suitable candidates. Jobs with salaries receive more, high
            quality applications.
          </Text>
        </ContentWrapper>
        <Clickable
          onClick={handleClickClose}
          data-testid="missing-salary-warning-close-button"
        >
          <Icon icon="close" size={1} />
        </Clickable>
      </Wrapper>
    </Alert>
  );
};
